import React, {FC, useState} from 'react';

const tabs = [
    {name: '전체 스토어', type: undefined, pathname: '/my/orders/all/all-stores'},
    {name: '온라인 스토어', type: 'ONLINE', pathname: '/my/orders/all/online-store'},
    {name: '오프라인 스토어', type: 'OFFLINE', pathname: '/my/orders/all/offline-store'},
];

export interface MyPageStoreTabsProps {
    onChange: (type: 'ONLINE' | 'OFFLINE' | undefined) => void
}

export const MyPageStoreTabs: FC<MyPageStoreTabsProps> = ({onChange}) => {
    const [tab, setTab] = useState(tabs[0]);

    return (
        <div className="space-x-3 mb-5">
            {tabs.map((t) => (
                <button key={t.name} className="" onClick={() => {
                    setTab(t);
                    // @ts-ignore
                    onChange(t.type)
                }}>
                    <p
                        className={`rounded-md font-semibold text-12 md:text-15 flex-shrink-0 px-3 md:px-8 py-3 ${
                            t.name === tab.name
                                ? 'filled-gray-900'
                                : 'filled-gray-100 text-gray-900'
                        }`}
                    >
                        {t.name}
                    </p>
                </button>
            ))}
        </div>
    );
};
